// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"232":"c22f6c89","480":"a583414a","588":"4ecf5d0e","612":"9d0078cb","616":"e6317c23","700":"b82ed589"}[chunkId] + ".chunk.css";
};